import { render, staticRenderFns } from "./Laboratorist.vue?vue&type=template&id=68a37eb2&scoped=true&"
import script from "./Laboratorist.vue?vue&type=script&lang=js&"
export * from "./Laboratorist.vue?vue&type=script&lang=js&"
import style0 from "./Laboratorist.vue?vue&type=style&index=0&id=68a37eb2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a37eb2",
  null
  
)

export default component.exports